import { apiClient } from "./client";

export interface BranchSummary {
  id: string;
  code: string;
  name: string;
  /** Addy Geo province national_code (string). Resolve to a name via useGeoNames(). */
  provinceCode?: string | null;
  status: string;
}

export interface BranchInput {
  code: string;
  name: string;
  address?: string | null;
  /** Addy Geo province national_code (string). */
  provinceCode?: string | null;
  /** Addy Geo ward national_code (string). */
  wardCode?: string | null;
  phone?: string | null;
}

interface SpringPage<T> {
  content: T[];
}

/** Branches client. List backs the switcher; CRUD backs the Chi nhánh settings page. */
export const branchesApi = {
  list(): Promise<BranchSummary[]> {
    return apiClient
      .get<SpringPage<BranchSummary>>("/v1/branches", { params: { size: 100 } })
      .then((r) => r.data.content);
  },
  create(b: BranchInput): Promise<{ id: string }> {
    return apiClient.post<{ id: string }>("/v1/branches", b).then((r) => r.data);
  },
  update(id: string, b: BranchInput): Promise<void> {
    return apiClient.put(`/v1/branches/${id}`, b).then(() => undefined);
  },
  archive(id: string): Promise<void> {
    return apiClient.post(`/v1/branches/${id}/archive`).then(() => undefined);
  },
  /** Hard delete (permanent). 409 nếu chi nhánh đang được tham chiếu. */
  remove(id: string): Promise<void> {
    return apiClient.delete(`/v1/branches/${id}/permanent`).then(() => undefined);
  },
};

export const branchesQueryKeys = {
  all: () => ["branches"] as const,
};

/** The active branch id chosen in the switcher (empty = use tenant primary). */
export const ACTIVE_BRANCH_KEY = "addy.branchId";
